import { Badge, HorizontalContainer, VerticalContainer } from '@/components';
import type { CouponRedemptionViewModel } from '@/features/profile/model/types';
import { format, R } from '@/features/profile/resources/ProfileResources.resx';
import { GreenDotIcon, RedDotIcon } from '@/components/Icons';
import { Link } from 'react-router';

type CouponRedemptionCardProps = {
    couponRedemption: CouponRedemptionViewModel;
};

export const CouponRedemptionCard = ({
    couponRedemption,
}: CouponRedemptionCardProps) => (
    <Link
        aria-label={format(
            R.CouponLinkLabelA11y,
            couponRedemption.CouponName ?? '',
        )}
        to={`/CouponDetails?couponId=${couponRedemption.CouponRedemptionId}`}
        className="h-full min-h-28 cursor-pointer rounded-2xl border border-(--color-border-muted) p-4 hover:bg-(--color-bg-subtle)"
    >
        <VerticalContainer spacing="sm">
            <HorizontalContainer
                spacing="sm"
                className="min-h-7 flex-wrap items-start justify-between"
            >
                <HorizontalContainer
                    spacing="xs"
                    className="items-center pt-1 text-sm whitespace-nowrap"
                >
                    {couponRedemption.IsActive && (
                        <GreenDotIcon className="size-2" />
                    )}
                    {!couponRedemption.IsActive && (
                        <RedDotIcon className="size-2" />
                    )}
                    <span>{couponRedemption.StatusText}</span>
                </HorizontalContainer>

                <HorizontalContainer spacing="xs" className="flex-wrap">
                    {couponRedemption.ShowConsultationsUsed && (
                        <Badge type="information">
                            {couponRedemption.ConsultationsUsedText}
                        </Badge>
                    )}
                    {couponRedemption.ShowDiscount && (
                        <Badge type="promo">
                            {couponRedemption.DiscountText}
                        </Badge>
                    )}
                </HorizontalContainer>
            </HorizontalContainer>

            <VerticalContainer spacing="sm">
                <div className="overflow-hidden leading-tight font-bold text-ellipsis whitespace-nowrap text-(--color-text-heading)">
                    {couponRedemption.CouponName}
                </div>
                {couponRedemption.ExpiryDateString && (
                    <div className="leading-normal text-(--color-text-secondary)">
                        {couponRedemption.ExpiryDateString}
                    </div>
                )}
            </VerticalContainer>
        </VerticalContainer>
    </Link>
);
